import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './App.css';
import 'react-date-range/dist/styles.css'
import 'react-date-range/dist/theme/default.css'
import loadable from './utils/loadable';
import Loader from './components/commonComponents/Loader';
import Layout from './components/Layout';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ChangePassword from './components/ChangePassword';

const Login = loadable(() => import('./components/Login'), <Loader />)
const Dashboard = loadable(() => import('./components/Dashboard'), <Loader />)
const Users = loadable(() => import('./components/users/Users'), <Loader />)
const UpdateSettings = loadable(() => import('./components/settings/UpdateSettings'), <Loader />)
const Alarms = loadable(() => import('./components/alarms/Alarms'), <Loader />)
const AlarmDetails = loadable(() => import('./components/alarms/AlarmsDetails'), <Loader />)
const MotiTags = loadable(() => import('./components/moti_tags/MotiTags'), <Loader />)
const UserDetails = loadable(() => import('./components/users/UserDetails'), <Loader />)
const Leagues = loadable(() => import('./components/leagues/Leagues'), <Loader />)
const LeagueDetails = loadable(() => import('./components/leagues/LeagueDetails'), <Loader />)
const UserFeedback = loadable(() => import('./components/user_feedbacks/UserFeedback'), <Loader />)
const Reports = loadable(() => import('./components/reports/analytics'), <Loader />)

function App() {
  return (
    <>
      <ToastContainer
        pauseOnFocusLoss={false}
        hideProgressBar={true}
      />
      <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true}}>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<Layout />}>
            <Route index element={<Dashboard />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="users" element={<Users />} />
            <Route path="users/details/:id" element={<UserDetails />} />
            <Route path="settings" element={<UpdateSettings />} />
            <Route path="alarms" element={<Alarms />} />
            <Route path="alarms/details/:id" element={<AlarmDetails />} />
            <Route path="leagues" element={<Leagues />} />
            <Route path="leagues/details/:id" element={<LeagueDetails />} />
            <Route path="moti_tags" element={<MotiTags />} />
            <Route path="user_feedback" element={<UserFeedback />} />
            <Route path="reports" element={<Reports />} />
            <Route path="change-password" element={<ChangePassword />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
